import type { InterventionTabDetailsProps } from "./intervention-tab-details.type";

import InterventionMenuCard from "@/modules/intervention/intervention-menu-card";
import InterventionSectionCard from "@/modules/intervention/intervention-section-card";
import { InterventionSectionProvider } from "@/modules/intervention/intervention-section-context";
import { useThemeBreakpoints } from "@/services/theme";

import { CONTENT_HEIGHT } from "./intervention-tab-details.constant";

import "./intervention-tab-details.style.less";

const InterventionTabDetails = ({
  intervention,
  interventionAsset,
}: InterventionTabDetailsProps) => {
  const { activeBreakpoint, isLargeScreen } = useThemeBreakpoints();

  return (
    <div
      className={`intervention-tab-details -${activeBreakpoint}`}
      style={isLargeScreen ? { height: CONTENT_HEIGHT } : undefined}
    >
      <InterventionSectionProvider
        interventionAsset={interventionAsset}
        intervention={intervention}
      >
        <InterventionMenuCard />
        <InterventionSectionCard />
      </InterventionSectionProvider>
    </div>
  );
};

export default InterventionTabDetails;
